import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';

@Component({
  selector: 'rt-subscription-banner',
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionBannerComponent {
  @Input() public type: 'normal' | 'warning' | 'information';
  @Input() public iconName: IconName;
  @Input() public message: string;
  @Input() public linkUrl: any[];
  @Input() public linkText: null | string;

  @Input() public isDismissible: boolean;

  @Output() public linkClick = new EventEmitter<void>();
  @Output() public closeBanner = new EventEmitter<MouseEvent>();

  public onCloseClick(event: MouseEvent) {
    this.closeBanner.emit(event);
  }
}
